import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { PreviewModal } from 'hlj-components'
import store from './store'

@observer
export default class extends Component {
  componentDidMount() {
    store.getPoster()
  }

  render() {
    const { poster, image_path } = store

    return image_path ? (
      <PreviewModal visible={poster} onCancel={store.hidePoster}>
        <img onClick={store.hidePostertoLink} src={image_path} />
      </PreviewModal>
    ) : null
  }
}
